import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import "popper.js";
import "jquery";
import 'bootstrap';
import './scss/main.scss';
import "./libs/fontawesome/js/all";

import Home from './core/Home';

const Routes = () => {
  return ( <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Home} />
      </Switch>
  </BrowserRouter>
  );
};

export default Routes;